<template>
    <transition name="el-fade-in-linear">
        <div v-show="showMain" class="transition-box">
            <div id="formblock">
                <el-form label-position="top" label-width="80px" :model="searchForm">
                    <el-row>
                        <el-col :span="6">
                            <el-form-item label="日期範圍">
                                <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="~" start-placeholder="" end-placeholder="" @change="onClear('date')" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <el-row type="flex" justify="center">
                    <el-col :span="6" style="margin-top:auto;margin-bottom:auto;">
                        <el-button style="width: 100%" type="primary" @click="onSearch" v-show="store.getters.check_auth('SEARCH')">Search</el-button>
                    </el-col>
                </el-row>
            </div>
            <div id="datablock" style="height: calc(100vh - 352px)">
                <div ref="table" style="margin-top:10px;"></div>

                <!-- 下步動作 -->
                <el-dialog width="500px" v-model="dialogVisible" title="[下步動作]" @opened="onDialogOpen" center label-width="" :lock-scroll="false" :close-on-click-modal="false">
                    <el-row>
                        <el-text class="mx-1">訂單編號:{{ form.WORK_NO }}</el-text>
                    </el-row>
                    <el-row>
                        <el-text class="mx-1">託運單號:{{ form.DLV_NO }}</el-text>
                    </el-row>
                    <el-row>
                        <el-text class="mx-1">最後狀態:{{ form.LAST_STATUS_CODE }}/{{ form.LAST_STATUS }}</el-text>
                    </el-row>
                    <el-row>
                        <el-text class="mx-1">作業時間:{{ form.LAST_STATUS_TIME }}</el-text>
                    </el-row>
                    <el-row align="middle">
                        <el-text class="mx-1" size="large">Next Action:</el-text>
                        <el-select v-model="statusValue" class="m-2" placeholder="Select">
                            <el-option v-for="item in statusOptions"
                                       :key="item.value"
                                       :label="item.label"
                                       :value="item.value" />
                        </el-select>
                    </el-row>
                    <template #footer>
                        <span class="dialog-footer">
                            <el-button @click="onNextStatusClick" :disabled="btnDisable">確定</el-button>
                            <el-button @click="dialogVisible = false">取消</el-button>
                        </span>
                    </template>
                </el-dialog>
            </div>

            <!-- 貨況區塊 -->
            <div id="popover" style="position: absolute; width: fit-content; margin: 10px; padding: 10px; background: white; border: #00BFFF solid 1.5px; box-shadow: 0 10px 10px -10px; z-index: 9999">
                <el-row>
                    <el-text class="mx-1">訂單編號:{{ form.WORK_NO }}</el-text>
                </el-row>
                <el-row>
                    <el-text class="mx-1">託運單號:{{ form.DLV_NO }}</el-text>
                </el-row>
                <el-table :data="statusForm">
                    <el-table-column width="100" property="STATUS_NAME" label="作業狀態" />
                    <el-table-column width="150" property="STATUS_TIME" label="作業時間" />
                    <el-table-column width="200" property="REMARKS" label="備註說明" />
                </el-table>
            </div>
        </div>
    </transition>
</template>

<script setup>
    import { ref, reactive, onBeforeMount, onMounted, nextTick } from 'vue';
    import { createPopper } from '@popperjs/core';
    import { TabulatorFull as Tabulator } from 'tabulator-tables'; //import Tabulator library
    import { ElMessage, ElMessageBox } from 'element-plus'
    import axios from 'axios';
    import $api from '@/utils/axios';
    import { useStore } from "vuex";
    const store = useStore();

    const showMain = ref(true);//顯示主頁面
    const dialogVisible = ref(false);//顯示dialog
    const formData = ref(null);
    const btnDisable = ref(false);//下步動作確定按鈕的開關
    const statusValue = ref('');//選取狀態
    const statusOptions = ref([]); //狀態下拉

    const searchForm = reactive({
        DATE: []
    });

    const form = ref({
        DLV_SEQ:'',
        DLV_NO: '',
        WORK_NO: '',
        LAST_STATUS_CODE: '',
        LAST_STATUS: '',
        LAST_STATUS_TIME:''
    });

    const statusForm = ref(null);

    const table = ref(null); //reference to your table element
    const tabulator = ref(null); //variable to hold your table

    const onLoadTable = () => {
        var start_date = searchForm.DATE[0].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
        var end_date = searchForm.DATE[1].toLocaleString('default', { year: "numeric", month: "2-digit", day: "2-digit" });
        
        $api.GET('/api/ApiTest/GetTableData', {
            DEPT_START_DATE: start_date, DEPT_END_DATE: end_date
        }).then((response) => {
            tabulator.value.setData(response);
        });
    }

    const onNextStatusClick = () => {
        $api.POST('/api/ApiTest/NextStatus', {
            DLV_SEQ: form.value.DLV_SEQ, STATUS_CODE: statusValue.value
        }).then((response) => {
            console.log(response);
            dialogVisible.value = false;
            onLoadTable()
        });
    };

    const onSearch = () => {
        console.log(searchForm);
        if (searchForm.DATE.length == 0 || searchForm.DATE == null) {
            ElMessageBox.alert('請選擇日期', '提示', { confirmButtonText: '確定', type: 'warning' });
        } else {
            onLoadTable();
        }
    };

    const onDialogOpen = () => {
        nextTick(() => {
            statusValue.value = '';
            btnDisable.value = false;
            form.value = formData.value;
            statusOptions.value = [];
            switch (form.value.LAST_STATUS_CODE) {
                case 'ST01':
                    statusOptions.value = [{ label: "運輸公司接單", value: "ST02" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case 'ST02':
                    statusOptions.value = [{ label: "司機接單", value: "ST022" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case 'ST021':
                    statusOptions.value = [{ label: "司機接單", value: "ST022" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case "ST022":
                    statusOptions.value = [{ label: "司機拒單", value: "ST021" }, { label: "取消訂單", value: "ST024" },
                    { label: "抵達取貨地", value: "ST025" }];
                    break;
                case "ST023":
                    statusOptions.value = [{ label: "取消訂單", value: "ST024" }];
                    break;
                case "ST024":
                    statusOptions.value = [{ label: "運輸公司接單", value: "ST02" }, { label: "取消託運單", value: "ST05" }];
                    break;
                case "ST025":
                    statusOptions.value = [{ label: "取貨完成", value: "ST03" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case "ST03":
                    statusOptions.value = [{ label: "抵達卸貨地", value: "ST035" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case "ST035":
                    statusOptions.value = [{ label: "貨品送達", value: "ST04" }, { label: "取消訂單", value: "ST024" }];
                    break;
                case "ST04":
                    btnDisable.value = true;
                    break;
                case "ST05":
                    btnDisable.value = true;
                    break;
                default:
                    console.log(form.value.LAST_STATUS_CODE);
            }
        });
    };

    const onClear = (select) => {
        switch (select) {
            case 'search':
                searchForm.DATE = [];
                break;
            case 'date':
                if (searchForm.DATE == null) searchForm.FAST_SEARCH = '';
                break;
        }
    };

    const workNo = ref(null);
    const onDetailClick = (e, cell) => {
        form.value = JSON.parse(JSON.stringify(cell.getData()));
        const btn = document.querySelector('#' + cell.getRow().getData().WORK_NO);
        const popover = document.querySelector('#popover');
        popover.style.display = "block";
        createPopper(btn, popover, {
            placement: 'bottom'
        });
        $api.GET('/api/DlvNoteStatus/GetStatus', {
            DLV_SEQ: cell.getRow().getData().DLV_SEQ
        }).then((response) => {
            statusForm.value = response;
            btn.removeChild(btn.children[0]);
            var icon = '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="m488.832 344.32-339.84 356.672a32 32 0 0 0 0 44.16l.384.384a29.44 29.44 0 0 0 42.688 0l320-335.872 319.872 335.872a29.44 29.44 0 0 0 42.688 0l.384-.384a32 32 0 0 0 0-44.16L535.168 344.32a32 32 0 0 0-46.336 0z"></path></svg></i>';
            btn.innerHTML = icon;
            workNo.value = cell.getRow().getData().WORK_NO;
        });
    }

    const onPicClick = (e, cell) => {
        dialogVisible.value = true;
        formData.value = JSON.parse(JSON.stringify(cell.getData()));
        if (formData.value.FILE_NAME != null && formData.value.FILE_NAME != '') {
            formData.value.FILE_NAME = 'http://192.168.0.7:80/RDD_TRANS/photos/' + formData.value.FILE_NAME;
        }
    };

    const DetailIcon = (cell, formatterParams, onRendered) => {
        var container = document.createElement('button');
        container.setAttribute('id', cell.getRow().getData().WORK_NO);
        container.setAttribute('class', 'el-button');
        container.setAttribute('type', 'button');
        container.setAttribute('v-popover', 'popoverRef');
        container.setAttribute('aria-disabled', 'false');
        container.setAttribute('style', 'font-size: 20px; padding: 5px;');
        var icon = '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path></svg></i>';
        container.innerHTML = icon;

        return container;
    };

    const ReportIcon = (cell, formatterParams) => {
        return '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-029747aa=""><path fill="currentColor" d="M192 128v768h640V128H192zm-32-64h704a32 32 0 0 1 32 32v832a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h192v64H320v-64zm0 384h384v64H320v-64z"></path></svg></i>';
    };

    onMounted(() => {
        //instantiate Tabulator when element is mounted
        tabulator.value = new Tabulator(table.value, {
            locale: "zh-tw",
            layout: "fitColumns",      //fit columns to width of table
            maxHeight: "100%", //do not let table get bigger than the height of its parent element
            columnHeaderVertAlign: "middle", //align header contents to middle of cell
            headerVisible: false,
            pagination: true,       //paginate the data
            paginationSize: 50,         //allow 50 rows per page of data
            paginationSizeSelector: [50, 100, 200],
            columns: [
                { title: "序號", formatter: "rownum", width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false },
                {
                    title: "", field: "WORK_NO", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        // 時間格式 MM/DD hh:mm:ss
                        var datetime = new Date(cell.getRow().getData().LAST_STATUS_TIME).toLocaleString([], { month: "2-digit", day: "2-digit", hour12: false, hour: "2-digit", minute: "2-digit", second: "2-digit" });
                        return cell.getValue() + '<br/>' + cell.getRow().getData().LAST_STATUS + ':' + datetime;
                    }
                },
                { title: "TRN_LGS", field: "TRN_LGS", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false },
                {
                    title: "", field: "DEPT_COMP_NAME", headerHozAlign: "center", hozAlign: "left", vertAlign: "middle", headerSort: false,
                    formatter: function (cell, formatterParams, onRendered) {
                        return cell.getValue() + '-' + cell.getRow().getData().DEST_COMP_NAME + '<br/>' + cell.getRow().getData().DEST_ADDR;
                    }
                },
                { title: "", field: "detail", formatter: DetailIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onDetailClick },
                { title: "PIC", field: "pic", formatter: ReportIcon, width: 50, headerHozAlign: "center", hozAlign: "center", vertAlign: "middle", headerSort: false, cellClick: onPicClick }
            ],
            langs: {
                "zh-tw": {
                    "pagination": {
                        "page_size": "選擇筆數",
                        "first": "第一頁",
                        "last": "最後一頁",
                        "prev": "上一頁",
                        "next": "下一頁",
                    }
                }
            },
        });
        tabulator.value.on("tableBuilt", function () {
            if (!store.getters.check_auth('MODIFY')) {
                tabulator.value.hideColumn('edit');
            }
        });
    });

    document.addEventListener('mousedown', function (e) {
        const popover = document.querySelector('#popover');
        if (popover.style.display == "block") {
            popover.style.display = "none";
            const btn = document.querySelector('#' + workNo.value.toString());
            btn.removeChild(btn.children[0]);
            var icon = '<i class="el-icon"><svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg" data-v-ea893728=""><path fill="currentColor" d="M831.872 340.864 512 652.672 192.128 340.864a30.592 30.592 0 0 0-42.752 0 29.12 29.12 0 0 0 0 41.6L489.664 714.24a32 32 0 0 0 44.672 0l340.288-331.712a29.12 29.12 0 0 0 0-41.728 30.592 30.592 0 0 0-42.752 0z"></path></svg></i>';
            btn.innerHTML = icon;
        }
    });

</script>

<style></style>
